export default __webpack_public_path__ + "static/media/Roboto-Regular.a8d6ac03.ttf";